import {
  BaseTable,
  SortConfig,
  type Column,
} from '@/components/table/BaseTable'
import { HealthInsurersList } from '@/types/healthInsurersList'
import { css, Theme } from '@emotion/react'
import { Link } from 'react-router-dom'

const dateFormatter = new Intl.DateTimeFormat('ja-JP', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

const tableWrapperStyles = css`
  overflow-x: auto;
`
const LinkStyle = (t: Theme) => css`
  cursor: pointer;
  text-decoration: none;
  color: ${t.c.bc.primary};

  &:hover {
    text-decoration: underline;
  }
`

const startDateWidth = 160
const insurerCodeWidth = 120
const nameWidth = 440
const insuranceTypeWidth = 200
const addressWidth = 220
const insurerDestinationNameWidth = 220
const insurerDestinationNameAcumoxiWidth = 220
const columns: Column<HealthInsurersList>[] = [
  {
    header: '適用開始日',
    /**
     * 適用開始日をyyyy/MM/dd形式でフォーマットする
     * @param row HealthInsurersList
     * @returns string
     */
    text: (row) => {
      return dateFormatter.format(new Date(row.startDate))
    },
    width: `${startDateWidth}px`,
    divStyle: {
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    sortKey: 'start_date',
  },
  {
    header: '保険者番号',
    accessor: (row) => {
      return (
        <Link css={LinkStyle} to={`${row.id}/view`}>
          {row.insurerCode}
        </Link>
      )
    },
    text: (row) => row.insurerCode,
    width: `${insurerCodeWidth}px`,
    isDetailLink: true,
    sortKey: 'insurer_code',
  },
  {
    header: '保険者名',
    text: (row) => row.name,
    width: `${nameWidth}px`,
  },
  {
    header: '保険種別',
    text: (row) => row.insuranceTypeName,
    width: `${insuranceTypeWidth}px`,
    sortKey: 'insurance_type',
  },
  {
    header: '住所',
    text: (row) =>
      row.addressLine1 + (row.addressLine2 ? `\n${row.addressLine2}` : ''),
    width: `${addressWidth}px`,
    isEllipsis: true,
  },
  {
    header: '送達先名',
    text: (row) => row.insurerDestinationName,
    width: `${insurerDestinationNameWidth}px`,
    isEllipsis: true,
  },
  {
    header: '送達先名（鍼灸）',
    text: (row) => row.insurerDestinationNameAcumoxi,
    width: `${insurerDestinationNameAcumoxiWidth}px`,
    isEllipsis: true,
  },
]

type Props = {
  data: HealthInsurersList[]
  sortConfig?: SortConfig
  onSort?: (key: string) => void
}

export const HealthInsurerTable = ({ data, sortConfig, onSort }: Props) => {
  return (
    <div css={tableWrapperStyles}>
      <BaseTable
        data={data}
        columns={columns}
        isDelete={false}
        needIcon={true}
        sortConfig={sortConfig}
        onSort={onSort}
        width={`${startDateWidth + insurerCodeWidth + nameWidth + insuranceTypeWidth + addressWidth + insurerDestinationNameWidth + insurerDestinationNameAcumoxiWidth}px`}
      />
    </div>
  )
}
